import React from "react";
import styled, { css } from "react-emotion";
import { withRedux } from "helpers";
import ImageItems from "./ImageItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Container = styled("div")`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  overflow-y: scroll;
  padding: 15px;
  max-height: ${(props) =>
    props.height ? props.height * 0.9 + "px" : "fit-content"};

  * {
    margin-bottom: 5px;
  }
  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

const menuBar = css`
  position: relative;
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

const hamburger = css`
  height: 33px;
  margin: 5px 5px 5px 10px;
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 1.5em;
`;

const MenuContainer = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  /* width: ${(props) => (props.showMenu ? "100%" : "0")}; */
  z-index: 1;
  background: white;
  /* transition: width 1s; */
`;

const menuItem = css`
  text-align: center;
  font-size: 2em;
  cursor: pointer;
  margin: 10px auto 10px auto;
  &:hover {
    background: grey;
  }
`;

const onHover = css`
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
`;

class PictureCatalogComponent extends React.Component {
  state = {
    showMenu: true,
    showSectionIdx: 0,
  };

  componentWillUnmount() {
    let { activeEditor } = this.props;

    if (activeEditor) {
      this.props.actions.refreshActiveEditor();
    }
  }

  updateActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;

    updateActiveEditor(idx);
  };

  toggleMenu = () => {
    const { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
    });
    this.updateActiveEditor(null);
  };

  selectSection = (showSectionIdx) => () => {
    this.setState({
      showSectionIdx,
      showMenu: false,
    });
  };

  renderMenu = () => {
    const { sections } = this.props;
    const { showMenu } = this.props;
    return (
      <MenuContainer showMenu={showMenu}>
        {sections &&
          sections.map((section, idx) => {
            const {
              header: { text },
            } = section;
            return (
              <div
                className={menuItem}
                key={idx}
                onClick={this.selectSection(idx)}
              >
                <p>{text}</p>
              </div>
            );
          })}
      </MenuContainer>
    );
  };

  filterSections = () => {
    const { sectionDisplayType, sections } = this.props;
    const { showSectionIdx } = this.state;

    switch (sectionDisplayType) {
      case "fullPage":
        return sections;
      // case "tableOfContents":
      //   this.updateActiveEditor(showSectionIdx);
      //   return sections[showSectionIdx] && [sections[showSectionIdx]];
      default:
        return sections;
    }
  };

  render() {
    const { columns, sections, sectionDisplayType } = this.props;
    // console.log("gallery props");
    // console.dir(this.props);
    // console.dir(sections);
    const { showMenu } = this.state;
    const filteredSections = this.filterSections();
    if (!filteredSections) return null;
    var appView = document.getElementById("appView");
    var appViewHeight = 750;
    if (appView && appView.offsetHeight < appViewHeight)
      appViewHeight = appView.offsetHeight;
    // if (appView) console.log();

    return (
      <Container height={appViewHeight}>
        {/* {sectionDisplayType === "tableOfContents" &&
          showMenu &&
          this.renderMenu()}
        {sectionDisplayType === "tableOfContents" && (
          <div className={menuBar} onClick={this.toggleMenu}>
            <div className={hamburger}>
              <FontAwesomeIcon icon="arrow-left" />
            </div>
            <h2>Back to Menu</h2>
          </div>
        )} */}
        {sections &&
          sections.map((s, idx) => {
            return (
              <div key={idx}>
                <p
                  style={{
                    ...s.header,
                    position: "relative",
                    textAlign: "center",
                  }}
                  className={onHover}
                  onClick={() => this.updateActiveEditor(idx)}
                >
                  {s.header.text}
                </p>
                {s.images && (
                  <ImageItems
                    columns={columns}
                    images={s.images}
                    onClick={() => this.updateActiveEditor(idx)}
                  />
                )}
              </div>
            );
          })}
      </Container>
    );
  }
}

export default withRedux(PictureCatalogComponent);
